const { PartnerPage } = require("./PartnerPage.js");

export default PartnerPage
